import { render, staticRenderFns } from "./DepositsReportsPopup.component.vue?vue&type=template&id=1b98073d&scoped=true&"
import script from "./DepositsReportsPopup.component.vue?vue&type=script&lang=js&"
export * from "./DepositsReportsPopup.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsReportsPopup.component.vue?vue&type=style&index=0&id=1b98073d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98073d",
  null
  
)

export default component.exports